import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  selected: boolean
}

const RadioInput = (props: Props) => {
  const { selected } = props

  return (
    <div
      className={cx('checkbox', {
        selected,
      })}
    >
      {selected && <Icon.Medium icon="check" color="grey000White" />}
    </div>
  )
}

export default RadioInput
